/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';

import {Observable} from 'rxjs';

import {DmpConfiguration} from '../model/dmpConfiguration';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorConfigurationService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer une configuration
     * Cette requête permet de créer une configuration.&lt;br&gt;Si la configuration est crée avec succès, la requête renvoie la configuration et un code 201.&lt;br&gt;Si la configuration a déjà un identifiant, la requête renvoie un code 400.
     * @param configuration configuration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createUsingPOST(configuration: DmpConfiguration, observe?: 'body', reportProgress?: boolean): Observable<DmpConfiguration>;
    public createUsingPOST(configuration: DmpConfiguration, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DmpConfiguration>>;
    public createUsingPOST(configuration: DmpConfiguration, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DmpConfiguration>>;
    public createUsingPOST(configuration: DmpConfiguration, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (configuration === null || configuration === undefined) {
            throw new Error('Required parameter configuration was null or undefined when calling createUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<DmpConfiguration>(`${this.basePath}/api/configurations/`,
            configuration,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister tout les configurations
     * Une configuration est un ensemble de paramètres qui permettent de définir 3 templates destinés aux utilisateurs : &lt;br&gt;&lt;ul&gt;&lt;li&gt; - Template pour l&#39;anonymisation&lt;/li&gt;&lt;br&gt;&lt;li&gt; - Template pour changer l&#39;email&lt;/li&gt;&lt;br&gt;&lt;li&gt; - Template pour la connexion à la dmp&lt;/li&gt;&lt;/ul&gt;&lt;br&gt;La configuration contient également un captcha et un token et sa période de validité.&lt;br&gt;Il faut noter que chaque configuration a un attribue &lt;b&gt;enabled&lt;/b&gt; qui permet de déterminer si la configuration est active ou non.&lt;br&gt;&lt;b&gt;Note&lt;/b&gt; : On aura toujours une et une seule configuration active à la fois.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<DmpConfiguration>>;
    public getAllUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DmpConfiguration>>>;
    public getAllUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DmpConfiguration>>>;
    public getAllUsingGET(observe: any = 'body', reportProgress = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DmpConfiguration>>(`${this.basePath}/api/configurations/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister les langues disponibles pour la configuration active
     * Cette requête permet de renvoyer les langues disponibles pour la configuration active.&lt;br&gt;Les langues seront représentées par leur code ISO 639-1.&lt;br&gt;Les langues disponibles : &lt;br&gt;&lt;ul&gt;&lt;li&gt; - fr&lt;/li&gt;&lt;br&gt;&lt;li&gt; - en&lt;/li&gt;&lt;br&gt;&lt;li&gt; - de&lt;/li&gt;&lt;br&gt;&lt;li&gt; - es&lt;/li&gt;&lt;br&gt;&lt;li&gt; - it&lt;/li&gt;&lt;br&gt;&lt;li&gt; - nl&lt;/li&gt;&lt;/ul&gt;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCurrentLanguesUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public getCurrentLanguesUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public getCurrentLanguesUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public getCurrentLanguesUsingGET(observe: any = 'body', reportProgress = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<string>>(`${this.basePath}/api/configurations/enable/langues`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister la configuration active
     * Cette requête permet de renvoyer la configuration active.&lt;br&gt;&lt;b&gt;Note&lt;/b&gt; : On aura toujours une et une seule configuration active à la fois.&lt;br&gt;Si aucune configuration n&#39;est active, la requête prend la responsabilité de créer une et la renvoyer.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCurrentUsingGET(observe?: 'body', reportProgress?: boolean): Observable<DmpConfiguration>;
    public getCurrentUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DmpConfiguration>>;
    public getCurrentUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DmpConfiguration>>;
    public getCurrentUsingGET(observe: any = 'body', reportProgress = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DmpConfiguration>(`${this.basePath}/api/configurations/enable`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer une configuration par son identifiant
     * Cette requête permet de récupérer une configuration par son identifiant.&lt;br&gt;Si la configuration existe, la requête renvoie la configuration et un code 200.&lt;br&gt;Si la configuration n&#39;existe pas, la requête renvoie un code 404.
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTenantUsingGET(id: string, observe?: 'body', reportProgress?: boolean): Observable<DmpConfiguration>;
    public getTenantUsingGET(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DmpConfiguration>>;
    public getTenantUsingGET(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DmpConfiguration>>;
    public getTenantUsingGET(id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTenantUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DmpConfiguration>(`${this.basePath}/api/configurations/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour une configuration
     * Cette requête permet de mettre à jour une configuration.&lt;br&gt;Si la modification est effectuée avec succès, la requête renvoie la configuration et un code 200.&lt;br&gt;Si non la requête renvoie un code 400.
     * @param configuration configuration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUsingPUT(configuration: DmpConfiguration, observe?: 'body', reportProgress?: boolean): Observable<DmpConfiguration>;
    public updateUsingPUT(configuration: DmpConfiguration, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DmpConfiguration>>;
    public updateUsingPUT(configuration: DmpConfiguration, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DmpConfiguration>>;
    public updateUsingPUT(configuration: DmpConfiguration, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (configuration === null || configuration === undefined) {
            throw new Error('Required parameter configuration was null or undefined when calling updateUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<DmpConfiguration>(`${this.basePath}/api/configurations/`,
            configuration,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
